/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 08/10/2025 - 21:23:07
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 08/10/2025
    * - Author          : 
    * - Modification    : 
**/
import React, { useState, useEffect } from "react";
import RegistrationFooter from "../../components/shared/registrationFooter";
import RegistrationNavbar from "../../components/shared/registrationNavbar";
import { Button } from "react-bootstrap";
import { Image } from "react-bootstrap";
import GoogleLogin from "../../components/pages/googleLogin";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/shared/loader";
import { getAuth, fetchSignInMethodsForEmail } from "firebase/auth";
import images from "../../images/index";
import { Link } from "react-router-dom";
import axios from "axios";

const Registered: React.FC = () => {
  const auth = getAuth();
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const [locationChecked, setLocationChecked] = useState(false);
  const [locationBlocked, setLocationBlocked] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    async function checkLocation() {
      try {
        if (locationChecked) return;
        const response = await axios.get('https://ipapi.co/json/');
        
        if (response.data.country_name === "United States" || 
            response.data.country_code === "US") {
          setLocationBlocked(true);
          setError("PV-GlareCheck is not available in your region");
        }
        
        setLocationChecked(true);
      } catch (error) {
        console.error("Error checking location:", error);
        setLocationChecked(true);
      }
    }
    
    checkLocation();
  }, [locationChecked]);

  const handelEmail = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const email = e.target.value.trim();
    setEmail(email);
    if (!locationBlocked) {
      setError("");
    }
  };
  
  const checkEmail = async () => {
    if (locationBlocked) {
      return;
    }
    
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    try {
      setLoader(true);
      
      if (!emailRegex.test(email)) {
        setLoader(false);
        setError("Invalid Email Address");
        return;
      }
      await fetchSignInMethodsForEmail(auth, email).then((methods) => {
        if (methods.length > 0) {
          setLoader(false);
          setError("Email address is already in use.");
        } else {
          setLoader(false);
          localStorage.setItem("userEmail", email);
          navigate("/register");
        }
      });
    } catch (error) {
      setLoader(false);
      setError("Something is wrong please try again");
    }
  };

  return (
    <React.Fragment>
      <RegistrationNavbar />
      <div className="text-center my-5">
        <div className="d-flex my-3 align-items-center ">
          <Link
            style={{ width: "fit-content", position: "absolute" }}
            className="text-decoration-none"
            to="/login"
          >
            <div className="ms-3 d-flex align-items-center">
              <Image className="mb-3 me-1" src={images.leftArrow} width={20} height={20} alt="back_arrow" />
              <p className="d-none d-sm-inline mx-1 backToDashboard">Login</p>
            </div>
          </Link>
          <h1 className="newProjects mx-auto pe-5">Register</h1>
        </div>
        <input
          onKeyDown={(e) => {
            if (e.key === "Enter" && !locationBlocked) {
              checkEmail();
            }
          }}
          onChange={handelEmail}
          className="loginInput my-3"
          type="email"
          placeholder="Email"
          disabled={locationBlocked} 
        />

        <span className="text-danger d-block error">{error}</span>
        <br />
        <p className="loginOR">Or</p>
        <GoogleLogin />
        <br />
        <Button className="facebookLogin my-3 " variant="none">
          <Image width={20} className="pb-1 mx-2" src={images.FacebookIcon} /> Facebook
        </Button>
        <br />
        <Button variant="none" className="login" onClick={checkEmail} disabled={locationBlocked}>
          {loader ? (
            <span className="d-flex justify-content-center">
              {" "}
              <Loader />
            </span>
          ) : (
            "Register"
          )}
        </Button>
      </div>
      <RegistrationFooter />
    </React.Fragment>
  );
};
export default Registered;